import apiClient from './api';

export type ServiceProviderCertificationStatus = 'reviewing' | 'approved' | 'rejected';
export type ServiceProviderCertificationSearchStatus = ServiceProviderCertificationStatus | 'all';
export type ServiceProviderAccountStatus = 'active' | 'inactive';

export interface ServiceProviderCertificationListParams {
  page?: number;
  pageSize?: number;
  keyword?: string;
  serviceRegion?: string;
  certificationStatus?: ServiceProviderCertificationSearchStatus;
}

export interface ServiceProviderCertificationListItem {
  id: string;
  username: string;
  name: string;
  avatar: string;
  phone: string;
  wechatNickname: string;
  levelName: string;
  serviceRegion: string;
  serviceProjects: string[];
  serviceProjectsText: string;
  certificationStatus: ServiceProviderCertificationStatus;
  certificationRemark: string;
  certificationSubmittedAt: string;
  certificationReviewedAt: string;
  accountStatus: ServiceProviderAccountStatus | string;
  lastLoginAt: string;
  createdAt: string;
}

export interface ServiceProviderCertificationDetail {
  id: string;
  username: string;
  name: string;
  avatar: string;
  phone: string;
  appType: string;
  appId: string;
  openId: string;
  unionId: string;
  wechatNickname: string;
  wechatAvatarUrl: string;
  levelName: string;
  serviceProvince: string;
  serviceCity: string;
  serviceDistrict: string;
  serviceRegion: string;
  serviceLatitude: number;
  serviceLongitude: number;
  serviceAddressDetail: string;
  serviceExperience: string;
  serviceProjects: string[];
  serviceProjectsText: string;
  idCardFrontUrl: string;
  idCardBackUrl: string;
  extraMaterialUrl: string;
  bio: string;
  certificationStatus: ServiceProviderCertificationStatus;
  certificationRemark: string;
  certificationSubmittedAt: string;
  certificationReviewedAt: string;
  orderMode: boolean;
  notifyEnabled: boolean;
  accountStatus: ServiceProviderAccountStatus | string;
  lastLoginAt: string;
  lastLoginIp: string;
  createdAt: string;
  updatedAt: string;
}

export interface ServiceProviderCertificationListResponse {
  list: ServiceProviderCertificationListItem[];
  total: number;
  page: number;
  pageSize: number;
}

export interface ReviewCertificationRequest {
  certificationStatus: 'approved' | 'rejected';
  certificationRemark?: string;
}

export const listServiceProviderCertifications = async (
  params?: ServiceProviderCertificationListParams,
): Promise<ServiceProviderCertificationListResponse> => {
  const response = await apiClient.get<ServiceProviderCertificationListResponse>(
    '/service-provider-certifications',
    { params },
  );
  return response.data;
};

export const getServiceProviderCertificationDetail = async (
  id: string,
): Promise<ServiceProviderCertificationDetail> => {
  const response = await apiClient.get<ServiceProviderCertificationDetail>(
    `/service-provider-certifications/${id}`,
  );
  return response.data;
};

export const reviewServiceProviderCertification = async (
  id: string,
  data: ReviewCertificationRequest,
): Promise<ServiceProviderCertificationDetail> => {
  const response = await apiClient.put<ServiceProviderCertificationDetail>(
    `/service-provider-certifications/${id}/review`,
    data,
  );
  return response.data;
};
